export const setAuthToken = (tkn: string) => {
  sessionStorage.setItem("auth", tkn);
};

export const getAuthToken = () => {
  return sessionStorage.getItem("auth");
};
